import { ValidatorFn, AbstractControl, FormControl  } from '@angular/forms';

export function fileExtensionValidator(validExt: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let forbidden = true;
    if (control.value) {
      const fileExt = control.value.split('.').pop();
      validExt.split(',').forEach(ext => {
        const extFinal=ext.replace(/\./g, "").trim()
        if (extFinal.toUpperCase() === fileExt.toUpperCase()) {
          forbidden = false;
        }
      });
    }
    return forbidden ? { 'inValidExt': true } : null;
  };
}

